/**
 * Admin Goals State Types
 *
 * Type definitions for the Admin Goals state slice.
 * Real-time synced state with local caching for all goals across the team.
 */

import { AugmentedGoal } from 'src/app/domain/goals/types/Goal.model';

/** Signal state model for the AdminGoalsState slice. */
export interface AdminGoalsStateModel {
  // === Data ===
  data: AugmentedGoal[];

  // === Status Flags ===
  initialized: boolean;
  loading: boolean;
  error: string | null;

  // === Metadata ===
  lastUpdated: number | null;
  lastSync: number | null;
  hydratedFromCache: boolean;

  // === Context ===
  activeTeamId: string | null;
}

/** Configuration required to initialize AdminGoalsState for a team. */
export interface AdminGoalsInitConfig {
  activeTeamId: string;
  enableRealtimeUpdates?: boolean;
}

export const ADMIN_GOALS_DEFAULTS: AdminGoalsStateModel = {
  data: [],
  initialized: false,
  loading: false,
  error: null,
  lastUpdated: null,
  lastSync: null,
  hydratedFromCache: false,
  activeTeamId: null,
};
